/* Product page section nav (mobile and tablet, under 990px). Jacob, 21 Oct 2026: "the product pages are so long on
   mobile, you need a mini-navigation that follows you down the page".
   Builds itself from whichever sections the page actually has, in page order, so a part, a tip and a sprayer each get
   only their own links. Appears once the buy row has scrolled away, sits under the sticky header, highlights the
   section in view and keeps that link scrolled into the strip. Hides again near the footer. */
(function () {
  var nav = document.querySelector('[data-pdp-secnav]');
  if (!nav) return;
  var strip = nav.querySelector('[data-secnav-strip]');
  var DEFS = [
    ['#need', 'What you need'],
    ['#size', 'Sizes'],
    ['.pdp-over', 'Overview'],
    ['#specs', 'Specs'],
    ['#kit', 'Kit'],
    ['#parts', 'Parts'],
    ['.pdp-fits', 'Fits'],
    ['[aria-labelledby="BoxTitle"]', 'In the box'],
    ['#docs', 'Manuals'],
    ['#warranty', 'Delivery'],
    ['.apps-section', 'Reviews'],
    ['#faq', 'Questions']
  ];
  var items = [];
  DEFS.forEach(function (d, i) {
    var el = document.querySelector(d[0]);
    if (!el || !el.offsetParent) return;
    if (!el.id) el.id = 'sec-' + i;
    items.push({ el: el, label: d[1] });
  });
  items.sort(function (a, b) { return a.el.compareDocumentPosition(b.el) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; });
  if (items.length < 3) return;

  items.forEach(function (it) {
    var a = document.createElement('a');
    a.href = '#' + it.el.id;
    a.textContent = it.label;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var y = it.el.getBoundingClientRect().top + window.scrollY - offset() + 1;
      window.scrollTo({ top: y, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', '#' + it.el.id);
    });
    it.link = a;
    strip.appendChild(a);
  });

  var header = document.querySelector('.site-header');
  var anchor = document.querySelector('[data-atc-anchor]') || items[0].el;
  var footer = document.querySelector('.site-footer');
  var mq = matchMedia('(max-width: 989px)');
  var current = null, ticking = false;

  function headerBottom() { return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0; }
  function offset() { return headerBottom() + nav.offsetHeight + 8; }

  function update() {
    ticking = false;
    if (!mq.matches) { nav.hidden = true; return; }
    var top = headerBottom();
    nav.style.top = top + 'px';
    var past = anchor.getBoundingClientRect().bottom < top;
    var nearEnd = footer && footer.getBoundingClientRect().top < window.innerHeight;
    var show = past && !nearEnd;
    if (nav.hidden === show) nav.hidden = !show;
    if (!show) return;
    var line = top + nav.offsetHeight + 24, active = null;
    items.forEach(function (it) { if (it.el.getBoundingClientRect().top <= line) active = it; });
    if (active !== current) {
      if (current) current.link.removeAttribute('aria-current');
      current = active;
      if (current) {
        current.link.setAttribute('aria-current', 'true');
        var l = current.link;
        strip.scrollTo({ left: l.offsetLeft - (strip.clientWidth - l.offsetWidth) / 2, behavior: 'smooth' });
      }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
